import Typography from "@mui/material/Typography";
import CCOLink from "../../fundamentals/CCOLink";
import CCOPicture from "../../fundamentals/CCOPicture";
import Box from "@mui/material/Box";

export interface NavigationProps {
    navItem: any,
    height: string,
    picHeight: string,
    imageAspectRatio?: string,
    imageDimensions: {
        width: string,
        height: string
    },
    textHeight: string,
    isActive: boolean
}

function C091EasyLangTeaser(props: NavigationProps) {
    const teaser = props.navItem?.teaserSettings?.flyout_teaser || null;

    return (
        <CCOLink target={props.navItem} className={"easy-lang-teaser-link"}>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                background: props.isActive ? 'var(--sos-main)' : 'var(--background-white)',
                height: props.height,
                '.easy-lang-teaser-link:hover &': {
                    background: 'var(--sos-main)'
                }
            }}>
                <div style={{height: props.picHeight, aspectRatio: props.imageAspectRatio}}>
                    <Box
                        sx={{
                            width: "100%",
                            height: "100%",
                            overflow: 'hidden'
                        }}>
                        {(teaser && teaser.picture) ? (
                            <CCOPicture name="teaser pic" uri={teaser.picture}
                                        orientation="landscape_ratio16x9"
                                        width={props.imageDimensions.width}
                                        height={props.imageDimensions.height}
                                        sxImage={{width: '100%', height: '100%', objectFit: 'cover'}}
                                        sxContainer={{width: '100%', height: '100%'}}/>
                        ) : null}
                    </Box>
                </div>
                <div id={`child-${props.navItem.id}`}
                     style={{
                         marginBottom: '0',
                         marginTop: '0',
                         marginLeft: '16px',
                         marginRight: '16px',
                         height: props.textHeight,
                         display: 'flex',
                         alignItems: 'center',
                     }}>
                    <Typography
                        sx={{
                            fontSize: '18px',
                            color: props.isActive ? 'white' : 'var(--primary-text)',
                            '.easy-lang-teaser-link:hover &': {
                                color: 'white',
                                textDecoration: props.isActive ? 'none' : 'underline'
                            }
                        }}
                        data-cypress={`mainNavigationSpan${props.navItem.id}`}
                        variant={"navigationItem"}>
                        {props.navItem.teaserTitle ?? props.navItem.name}
                    </Typography>
                </div>
            </Box>
        </CCOLink>
    );
}

export default C091EasyLangTeaser;